import React from 'react';

import BaseListingRendererWithPlugins from 'nav/expanded/BaseListingRendererWithPlugins';
import {
  ColumnAccessorKey,
  ColumnConfiguration,
  ListingRendererType,
} from 'nav/expanded/ListingRendererConstants';
import {SortKey} from 'search/SearchConstants';
import {getColumnHeaderFromSortKey} from 'search/SortUtil';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {DatetimeTableCell} from 'ui-library/scrollable/table-cells/DatetimeTableCell';
import {BasicEvent} from 'util/Types';

import {ModelRunListingGraphQL} from '../../../graphql-fragments/model-hub/__generated/ModelRunListingGraphQL';

export default class ModelRunListingRenderer extends BaseListingRendererWithPlugins<ListingRendererType.MODEL_RUN> {
  listingRendererType = ListingRendererType.MODEL_RUN;

  renderIcon(): JSX.Element {
    // TODO(MODEL_RUN): Replace with actual model run icon when available
    return <BenchlingIcon icon="microscope" className="scrollableTable-cell-icon" />;
  }

  getNonPluginColumnConfigurations(
    items: Array<ModelRunListingGraphQL>
  ): Array<ColumnConfiguration<ModelRunListingGraphQL>> {
    const columns: Array<ColumnConfiguration<ModelRunListingGraphQL>> = [
      {
        column: {
          accessorKey: ColumnAccessorKey.NAME,
          header: 'Name',
          flexGrow: 1,
          isSortable: true,
          sortKey: SortKey.SORT_NAME_KEY,
        },
        render: (modelRun: ModelRunListingGraphQL) => modelRun.name,
      },
      {
        column: {
          accessorKey: ColumnAccessorKey.CREATED_AT,
          header: getColumnHeaderFromSortKey(SortKey.SORT_CREATED_AT_KEY),
          flexGrow: 1,
          isSortable: true,
          sortKey: SortKey.SORT_CREATED_AT_KEY,
        },
        render: (modelRun: ModelRunListingGraphQL) => (
          <DatetimeTableCell datetime={modelRun.createdAt} showTimeInCell={false} />
        ),
      },
      {
        column: {
          accessorKey: ColumnAccessorKey.MODIFIED_AT,
          header: getColumnHeaderFromSortKey(SortKey.SORT_MODIFIED_AT_KEY),
          flexGrow: 1,
          isSortable: true,
          sortKey: SortKey.SORT_MODIFIED_AT_KEY,
        },
        render: (modelRun: ModelRunListingGraphQL) => (
          <DatetimeTableCell datetime={modelRun.modifiedAt} showTimeInCell={false} />
        ),
      },
    ];

    return columns;
  }

  getNonPluginRowContentHeight(item: ModelRunListingGraphQL): number {
    return 40;
  }

  openContextMenu(item: ModelRunListingGraphQL, e: BasicEvent, extras: unknown): void {
    // Context menu not yet implemented for model runs
  }
}
